import { render, staticRenderFns } from "./PrivacyGuideSmishing.vue?vue&type=template&id=540156be&scoped=true"
import script from "./PrivacyGuideSmishing.vue?vue&type=script&lang=js"
export * from "./PrivacyGuideSmishing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540156be",
  null
  
)

export default component.exports